import React, { Component, Fragment } from "react";
import Footer from "./partials/Footer";
import Header from "./partials/Header";
import BgEvent from "../assets/imgs/bgEventPurchase.png";
import {
  Container,
  Row,
  Col,
  Fade,
  Alert,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Spinner,
} from "reactstrap";
import users from "../assets/imgs/users.png";
import { Redirect } from "react-router";
import { connect } from "react-redux";
import moment from "moment";
import {
  addGameToCard,
  addGameToUserFav,
  fetchGames,
  removeGameFromCard,
  removeGameFromUserFav,
} from "../redux/actions/gameActions";
import { relativeTimeThreshold } from "moment";
import { Link } from "react-router-dom";

export class EventPurchase extends Component {
  componentDidMount() {
    this.props.fetchGames();
    this.setState({ game: this.props.match.params.id });
    window.scrollTo(0, 0);
  }
  state = { loggedError: false, game: "" };
  isItemInCart = (id) => {
    let cart = JSON.parse(localStorage.getItem("cart"));
    if (cart != null) {
      let exist = cart.find((item) => item == id);
      if (exist) return true;
    }
    return false;
  };
  isItemInFav = (id) => {
    let user = JSON.parse(localStorage.getItem("user_info"));
    if (user != null) {
      let exist =
        user.my_favourites && user.my_favourites.find((item) => item == id);
      if (exist) return true;
    }
    return false;
  };
  getSuggestedEvents = (id) => {
    let { game } = this.props;
    if (!(game.games == null || game.games == -1))
      return game.games.filter((game) => game.id != id);
    return null;
  };
  checkUserLogged = () => {
    let user = JSON.parse(localStorage.getItem("user_info"));
    if (user != null) {
      return true;
    } else {
      return false;
    }
  };
  componentDidUpdate(prState, prevProps) {
    console.log(this.state.game, this.props.match.params.id);
    if (this.state.game != this.props.match.params.id) {
      this.setState({ game: this.props.match.params.id });
      window.scrollTo(0, 0);
    }
  }
  render() {
    if (!this.props.match.params.id) {
      return <Redirect to="/" />;
    }
    var { games } = this.props;
    var gameId = this.props.match.params.id;

    var thisGame =
      games && games.length && games.find((game) => game.id == gameId);

    return (
      <Fragment>
        <Header
          {...this.props}
          path={["Home", "Games"]}
          heading={thisGame && thisGame.title}
        />
        <Container className="margin-top-fix mb-5">
          <Row className="justify-content-end align-items-center">
            <Col xl={4} md={6} className="mt-3 mt-md-0">
              <div className="position-relative searchbar-wrapper">
                <input
                  type="text"
                  className="form-control bg-dark-1"
                  placeholder="Search"
                />
                <span
                  className="position-absolute"
                  style={{
                    top: "50%",
                    right: "25px",
                    transform: "translateY(-50%)",
                  }}
                >
                  <i className="fa fa-search text-white-1" />
                </span>
              </div>
            </Col>
          </Row>
          <div className="bg-purple-4 event-purchase-container mt-5">
            <Fade
              in={this.state.loggedError}
              onEnter={(e) =>
                window.setTimeout(() => {
                  this.setState({ loggedError: false });
                }, 5000)
              }
            >
              <Alert isOpen={this.state.loggedError} color="danger">
                Please signin to add games to favourites.
              </Alert>
            </Fade>
            <Row className="justify-content-center">
              <Col lg={6} md={10} sm={12}>
                <div
                  className="event-city-img event-city-img-1"
                  style={{
                    backgroundImage: `url(${thisGame && thisGame.img})`,
                  }}
                ></div>
              </Col>
              <Col lg={6} md={10} xs={11}>
                <div className="text-end mt-3 mt-lg-0">
                  {this.props.game.addGameToUserFav &&
                  this.props.game.addGameToUserFav == -1 ? (
                    <Spinner color="light" size="sm" />
                  ) : this.isItemInFav(thisGame && thisGame.id) ? (
                    <span
                      className="pointer"
                      onClick={(e) => {
                        this.props.removeGameFromUserFav(
                          thisGame && thisGame.id
                        );
                      }}
                    >
                      <i
                        className="fa fa-heart text-red-1"
                        style={{ fontSize: 30 }}
                      ></i>
                    </span>
                  ) : (
                    <span
                      className="pointer"
                      onClick={(e) => {
                        this.checkUserLogged()
                          ? this.props.addGameToUserFav(thisGame && thisGame.id)
                          : this.setState({ loggedError: true });
                      }}
                    >
                      <i
                        className="far fa-heart text-red-1"
                        style={{ fontSize: 30 }}
                      ></i>
                    </span>
                  )}
                </div>
                <Row className="justify-content-between mt-3">
                  <Col lg={8} sm={8} xs={12}>
                    <div className="text-white-1">
                      <CardTitle tag="h5">
                        {thisGame && thisGame.title}
                      </CardTitle>
                    </div>
                  </Col>
                  <Col lg={4} md={3} sm={4}>
                    <div className="text-end">
                      <CardSubtitle className="text-muted ">
                        {moment(
                          thisGame && thisGame.start_date.toDate()
                        ).format("DD MMM YYYY")}
                      </CardSubtitle>
                    </div>
                  </Col>
                </Row>
                <div className="mt-3 text-white-1">
                  <CardSubtitle>{thisGame && thisGame.address}</CardSubtitle>
                </div>
                <div className="mt-3 text-white-1">
                  <CardSubtitle>Gather your team! Solve the case!</CardSubtitle>
                </div>
                <Row className="justify-content-between mt-3">
                  <Col lg={8} sm={8} xs={9}>
                    <div className="text-white-1">
                      <CardSubtitle
                        className="text-lightpurple-1 mt-3"
                        style={{ fontSize: 14 }}
                      >
                        <img src={users} alt="user img" className="pe-3" />
                        Up To 6 Players in Team
                      </CardSubtitle>
                    </div>
                  </Col>
                  <Col lg={4} md={3} sm={3} xs={3}>
                    <div className="text-end text-white-1 mt-3">
                      <CardSubtitle>
                        {thisGame && thisGame.price} $
                      </CardSubtitle>
                    </div>
                  </Col>
                </Row>

                <Row className="justify-content-between align-items-end mt-5">
                  <Col xl={5} lg={6} sm={6} xs={7}>
                    <Button
                      onClick={(e) => {
                        this.isItemInCart(thisGame && thisGame.id)
                          ? this.props.removeGameFromCart(
                              thisGame && thisGame.id
                            )
                          : this.props.addGameToCart(thisGame && thisGame.id);
                      }}
                      className="bg-purple-1 w-100 text-white-1 mt-5 px-4 py-3"
                      style={{ borderRadius: 10, border: "none" }}
                    >
                      {this.isItemInCart(thisGame && thisGame.id) ? null : (
                        <i className="fas fa-cart-plus px-2"></i>
                      )}
                      <span className="px-2">
                        {this.isItemInCart(thisGame && thisGame.id)
                          ? "Remove"
                          : "Join Now"}
                      </span>
                    </Button>
                  </Col>
                  <Col lg={4} sm={4} xs={5}>
                    <div className="text-end">
                      <CardSubtitle
                        className="text-lightpurple-1"
                        style={{ fontSize: 14 }}
                      >
                        {/* <u>Last 9 tickets!</u> */}
                      </CardSubtitle>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Row className="ps-3 ps-lg-0 ">
                <Col xl={6} lg={6} md={10} sm={12}>
                  <h4 className="text-white-1 mt-5">About</h4>
                  <p className="text-lightpurple-1 mt-4">
                    {thisGame && thisGame.case_incident}
                  </p>
                </Col>
              </Row>
            </Row>
          </div>
          <div className="mt-5">
            <h4 className="text-white-1">Suggestion Events</h4>
            {this.getSuggestedEvents(thisGame && thisGame.id) == null ? (
              <div className="d-flex align-items-center justify-content-center my-5">
                <Spinner color="light" size="sm" />
              </div>
            ) : this.getSuggestedEvents(thisGame && thisGame.id).length == 0 ? (
              <div className="d-flex align-items-center justify-content-center my-5 text-white-1">
                No Game Yet.
              </div>
            ) : (
              <Row className="mb-5 mt-2">
                {this.getSuggestedEvents(thisGame && thisGame.id).map(
                  (game) => (
                    <Col
                      key={`GameCard${game.id}`}
                      xl={3}
                      lg={6}
                      md={6}
                      sm={6}
                      className="mt-4"
                    >
                      <Link
                        className="text-decoration-none"
                        to={"/event-purchase/" + game.id}
                        // to={{ pathname: "/event-purchase", state: game.id }}
                      >
                        <Card className="bg-dark-1 text-white-1 game-card">
                          <div
                            className="game-img game-img-1"
                            style={{ backgroundImage: `url(${game.img})` }}
                          ></div>
                          <CardBody>
                            <CardTitle tag="h6">{game.title}</CardTitle>
                            <CardSubtitle
                              tag="h6"
                              className="mb-2 text-muted mt-3"
                            >
                              {game.address}
                            </CardSubtitle>
                            <CardSubtitle
                              tag="h6"
                              className="mb-2 text-muted mt-3"
                            >
                              {moment(game.start_date.toDate()).format(
                                "DD MMM YYYY"
                              )}
                            </CardSubtitle>
                            <div className="d-flex mt-3">
                              <p className="mt-1">Price:</p>
                              <p className="px-2 mt-1 text-green-1">
                                ${game.price}
                              </p>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.isItemInCart(game.id)
                                    ? this.props.removeGameFromCart(game.id)
                                    : this.props.addGameToCart(game.id);
                                }}
                                className="ms-auto text-white-1 px-4 bg-dark-4 btn-join"
                              >
                                {this.isItemInCart(game.id)
                                  ? "Remove"
                                  : "Join Now"}
                              </button>
                            </div>
                          </CardBody>
                        </Card>
                      </Link>
                    </Col>
                  )
                )}
              </Row>
            )}
          </div>
        </Container>
        <Footer />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    game: state.game,
    games: state.game.games,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchGames: () => dispatch(fetchGames()),
    addGameToCart: (id) => dispatch(addGameToCard(id)),
    removeGameFromCart: (id) => dispatch(removeGameFromCard(id)),
    addGameToUserFav: (id) => dispatch(addGameToUserFav(id)),
    removeGameFromUserFav: (id) => dispatch(removeGameFromUserFav(id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EventPurchase);
